import {
  ChatBubbleOvalLeftEllipsisIcon,
  DocumentIcon,
  MicrophoneIcon,
  PencilSquareIcon,
} from '@heroicons/react/16/solid';

import { ArtifactType } from '@/services/types/artifact-digest-types';

interface ArtifactTypeBadgeProps {
  type: ArtifactType;
}

const getTypeConfig = (type: ArtifactType) => {
  switch (type) {
    case ArtifactType.BLOB:
      return {
        icon: DocumentIcon,
        label: 'File',
      };
    case ArtifactType.TRANSCRIPT:
      return {
        icon: MicrophoneIcon,
        label: 'Transcript',
      };
    case ArtifactType.CONVERSATION:
      return {
        icon: ChatBubbleOvalLeftEllipsisIcon,
        label: 'Conversation',
      };
    case ArtifactType.STAFF_NOTE:
      return {
        icon: PencilSquareIcon,
        label: 'Note',
      };
    default:
      return {
        icon: DocumentIcon,
        label: 'Artifact',
      };
  }
};

export const ArtifactTypeBadge = ({ type }: ArtifactTypeBadgeProps) => {
  const { icon: Icon, label } = getTypeConfig(type);

  return (
    <span className="flex items-center justify-center h-7 w-7">
      <Icon className="h-5 w-5 text-muted-foreground/40" title={label} />
    </span>
  );
};
